<se-fe-modal #modal>
  <div seFeModalHeader>
    <se-fe-modal-header
      seFeDataTitle="{{ 'UNCLAIM_PROFILE_MODAL.title' | translate: { name: persona?.first_name } }}"
      (seFeButtonAction)="modal.close()">
    </se-fe-modal-header>
  </div>
  <div seFeModalContent>
    <section>
      {{ "UNCLAIM_PROFILE_MODAL.message" | translate }}
    </section>

    <section *ngIf="failure" id="section-failure" class="pl-modal__footer pl-form-actions--condensed" style="text-align: left;">
      <div class="pl-form-actions__info">
        <se-fe-icon seFeDataName="warning" seFeDataSize="600" seFeDataColor="warn"></se-fe-icon>
        <span>{{ errorMessage }}</span>
      </div>
    </section>
 </div>
 <div seFeModalFooter>
   <se-fe-modal-footer
     [seFeDataFooterButtons]="options">
   </se-fe-modal-footer>
 </div>
</se-fe-modal>
